import React from 'react';
import '../scss/SortableHeader.scss';

const SortIcon = ({ sortDirection }) => {
    if (sortDirection === 'asc') return <span>▲</span>;
    if (sortDirection === 'desc') return <span>▼</span>;
    return <span>⬍</span>;
};

const SortableHeader = ({ column, label, sorted, onSortedChange }) => {
    const colSorted = sorted.find((s) => s.id === column.id);
    const currentDirection = colSorted ? (colSorted.desc ? 'desc' : 'asc') : null;

    const onClick = () => {
        let nextSort;
        if (!colSorted || colSorted.desc) {
            nextSort = [{ id: column.id, desc: false }];
        } else {
            nextSort = [{ id: column.id, desc: true }];
        }
        onSortedChange(nextSort, column);
    };

    return (
        <div
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onClick();
            }}
            className="sorting-icons"
            aria-label={`Sort by ${typeof label === 'string' ? label : ''}`}
            aria-sort={
                currentDirection === 'asc'
                    ? 'ascending'
                    : currentDirection === 'desc'
                      ? 'descending'
                      : 'none'
            }
        >
            <div>{label}</div>
            <SortIcon sortDirection={currentDirection} />
        </div>
    );
};

export default SortableHeader;
